<template>
  <div class="content-layout-switch">
    <button
      :class="{ active: isGridLayout }"
      @click="contentLayoutGridView"
    >
      <font-awesome-icon icon="th" />
      <span
        v-t="'c.contentLayoutSwitch.navigation.gridView'"
        class="visuallyhidden"
      />
    </button>

    <button
      :class="{ active: !isGridLayout }"
      @click="contentLayoutListView"
    >
      <font-awesome-icon icon="bars" />
      <span
        v-t="'c.contentLayoutSwitch.navigation.gridView'"
        class="visuallyhidden"
      />
    </button>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import FormMixin from '@/mixins/forms/Form'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'ContentLayoutSwitch',
  mixins: [FormMixin],
  components: {
    FontAwesomeIcon
  },
  computed: {
    ...mapState({
      layout: state => state.contentLayout.layout
    }),
    ...mapGetters([
      'isGridLayout'
    ])
  },
  methods: {
    ...mapActions([
      'contentLayoutGridView',
      'contentLayoutListView'
    ])
  }
}
</script>

<style lang="sass">
@import "~styles/imports"

.content-layout-switch
  display: flex
  align-items: center

  button
    background-color: transparent
    color: $color-grey-2
    padding-left: 5px
    padding-right: 5px
    outline: none

    &.active
      color: var(--mainColor)
</style>



// WEBPACK FOOTER //
// src/components/contents/ContentLayoutSwitch.vue